import React, { useState } from "react";
import { jsPDF } from "jspdf";
/* import bankLogo from "./bank-logo.png"; // optional bank logo */
import "./MIS.css";

export default function MISAccount() {
  const [accountHolder, setAccountHolder] = useState("");
  const [accountNumber, setAccountNumber] = useState("ACC" + Math.floor(100000 + Math.random() * 900000));
  const [branchName, setBranchName] = useState("");
  const [ifsc, setIfsc] = useState("TEST0000001");
  const [deposit, setDeposit] = useState("");
  const [rate, setRate] = useState(7.4);
  const [tenure, setTenure] = useState(5);
  const [accountType, setAccountType] = useState("Single");
  const [nomineeName, setNomineeName] = useState("");
  const [nomineeRelation, setNomineeRelation] = useState("");
  const [openingDate, setOpeningDate] = useState("");
  const [payoutOption, setPayoutOption] = useState("Monthly");
  const [maturityInstruction, setMaturityInstruction] = useState("Payout");
  const [monthlyInterest, setMonthlyInterest] = useState(0);
  const [totalInterest, setTotalInterest] = useState(0);
  const [maturityAmount, setMaturityAmount] = useState(0);

  // Interest calculation
  const calculateInterest = () => {
    const principal = parseFloat(deposit);
    const r = parseFloat(rate) / 100;
    const t = parseFloat(tenure);

    const totalInt = principal * r * t;
    let monthlyInt = totalInt / (t * 12);

    if (payoutOption === "Quarterly") monthlyInt = totalInt / (t * 4);
    else if (payoutOption === "Cumulative") monthlyInt = 0;

    const maturity = principal + totalInt;

    setMonthlyInterest(monthlyInt.toFixed(2));
    setTotalInterest(totalInt.toFixed(2));
    setMaturityAmount(maturity.toFixed(2));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    calculateInterest();
  };

  const handleReset = () => {
    setAccountHolder("");
    setBranchName("");
    setDeposit("");
    setRate(7.4);
    setTenure(5);
    setAccountType("Single");
    setNomineeName("");
    setNomineeRelation("");
    setOpeningDate("");
    setPayoutOption("Monthly");
    setMaturityInstruction("Payout");
    setMonthlyInterest(0);
    setTotalInterest(0);
    setMaturityAmount(0);
  };

  const handleDownloadPDF = () => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();

  // Header
  doc.setFontSize(20);
  doc.setTextColor(0, 55, 107);
  doc.setFont("helvetica", "bold");
  doc.text("AIRO BANK LIMITED", pageWidth / 2, 20, { align: "center" });

  doc.setFontSize(12);
  doc.setTextColor(80);
  doc.setFont("helvetica", "normal");
  doc.text(`Branch: ${branchName}`, pageWidth / 2, 28, { align: "center" });
  doc.text(`IFSC: ${ifsc}`, pageWidth / 2, 36, { align: "center" });

  doc.setDrawColor(0, 55, 107);
  doc.setLineWidth(0.8);
  doc.line(20, 42, pageWidth - 20, 42);

  // Section title
  doc.setFontSize(16);
  doc.setTextColor(0, 55, 107);
  doc.setFont("helvetica", "bold");
  doc.text("MIS Account Summary", 20, 50);

  // Table data
  const tableData = [
    { label: "Account Holder", value: accountHolder },
    { label: "Account Number", value: accountNumber },
    { label: "Deposit Amount", value: deposit },
    { label: "Interest Rate (%)", value: rate },
    { label: "Tenure (Years)", value: tenure },
    { label: "Account Type", value: accountType },
    { label: "Nominee Name", value: nomineeName || "-" },
    { label: "Nominee Relation", value: nomineeRelation || "-" },
    { label: "Opening Date", value: openingDate },
    { label: "Interest Payout Option", value: payoutOption },
    { label: "Maturity Instruction", value: maturityInstruction },
    { label: "Monthly Interest", value: monthlyInterest },
    { label: "Total Interest", value: totalInterest },
    { label: "Maturity Amount", value: maturityAmount },
    { label: "Early Withdrawal Info", value: "Penalty may apply" },
  ];

  let y = 60;
  const rowHeight = 12;
  const labelX = 32;
  const valueX = 90;

  tableData.forEach((row, index) => {
    // Ensure values are strings
    const valueText = row.value != null ? String(row.value) : "-";

    // Alternating row background
    doc.setFillColor(index % 2 === 0 ? 230 : 245);
    doc.rect(20, y - 8, pageWidth - 40, rowHeight, "F");

    // Row border (card style)
    doc.setDrawColor(200);
    doc.rect(20, y - 8, pageWidth - 40, rowHeight);

    // Label
    doc.setTextColor(0, 55, 107);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(12);
    doc.text(`${row.label}:`, labelX, y);

    // Value highlighting
    if (["Deposit Amount", "Total Interest", "Maturity Amount"].includes(row.label)) {
      doc.setTextColor(0, 128, 0);
      doc.setFont("helvetica", "bold");
    } else {
      doc.setTextColor(0, 0, 0);
      doc.setFont("helvetica", "normal");
    }
    doc.text(valueText, valueX, y);

    y += rowHeight + 3;

    // Page break
    if (y > 280) {
      doc.addPage();
      y = 20;
    }
  });

  // Footer
  doc.setFontSize(10);
  doc.setTextColor(120);
  doc.setFont("helvetica", "italic");
  doc.text(
    "This is a system generated MIS Account Summary. For official purposes, contact your branch.",
    20,
    y + 10
  );

  doc.save(`MIS_Summary_${accountNumber}.pdf`);
};


  return (
    <div className="mis-container">
      <h1>MIS Account Form</h1>
      <form className="mis-form" onSubmit={handleSubmit}>
        <div className="misform-grid">
          {/* 4-column professional form */}
          <div className="misform-row">
            <label>Account Holder Name :</label>
            <input type="text" value={accountHolder} onChange={(e) => setAccountHolder(e.target.value)} required />
          </div>
          <div className="misform-row">
            <label>Account Number :</label>
            <input type="text" value={accountNumber} readOnly />
          </div>
          <div className="misform-row">
            <label>Branch Name :</label>
            <input type="text" value={branchName} onChange={(e) => setBranchName(e.target.value)} required />
          </div>
          <div className="misform-row">
            <label>IFSC Code :</label>
            <input type="text" value={ifsc} onChange={(e) => setIfsc(e.target.value)} required />
          </div>

          <div className="misform-row">
            <label>Deposit Amount (₹) :</label>
            <input type="number" value={deposit} onChange={(e) => setDeposit(e.target.value)} required />
          </div>
          <div className="misform-row">
            <label>Interest Rate (%) :</label>
            <input type="number" value={rate} onChange={(e) => setRate(e.target.value)} required />
          </div>
          <div className="misform-row">
            <label>Tenure (Years) :</label>
            <input type="number" value={tenure} onChange={(e) => setTenure(e.target.value)} required />
          </div>
          <div className="misform-row">
            <label>Account Type :</label>
            <select value={accountType} onChange={(e) => setAccountType(e.target.value)}>
              <option>Single</option>
              <option>Joint</option>
            </select>
          </div>

          <div className="misform-row">
            <label>Nominee Name :</label>
            <input type="text" value={nomineeName} onChange={(e) => setNomineeName(e.target.value)} />
          </div>
          <div className="misform-row">
            <label>Nominee Relation :</label>
            <input type="text" value={nomineeRelation} onChange={(e) => setNomineeRelation(e.target.value)} />
          </div>
          <div className="misform-row">
            <label>Opening Date :</label>
            <input type="date" value={openingDate} onChange={(e) => setOpeningDate(e.target.value)} />
          </div>
          <div className="misform-row">
            <label>Interest Payout Option :</label>
            <select value={payoutOption} onChange={(e) => setPayoutOption(e.target.value)}>
              <option>Monthly</option>
              <option>Quarterly</option>
              <option>Year</option>
            </select>
          </div>

          <div className="misform-row">
            <label>Maturity Instruction :</label>
            <select value={maturityInstruction} onChange={(e) => setMaturityInstruction(e.target.value)}>
              <option>Payout</option>
              <option>Renew</option>
              <option>Transfer</option>
            </select>
          </div>
        </div>

        <div className="misform-buttons">
          <button type="submit">Submit</button>
          <button type="button" onClick={handleReset}>Reset</button>
          <button type="button" onClick={handleDownloadPDF}>Download PDF</button>
        </div>
      </form>

      {monthlyInterest > 0 && (
        <div className="mis-result">
          <h2>Calculation Result</h2>

          <div className="mis-highlight highlight-1">
            <span className="mis-label">Monthly Interest :</span> <span className="mis-value">₹{monthlyInterest}</span>
          </div>
          <div className="mis-highlight highlight-2">
            <span className="mis-label">Total Interest :</span> <span className="mis-value">₹{totalInterest}</span>
          </div>
          <div className="mis-highlight highlight-3">
            <span className="mis-label">Maturity Amount :</span> <span className="mis-value">₹{maturityAmount}</span>
          </div>
          <div className="mis-highlight highlight-4">
            <span className="mis-label">Interest Payout :</span> <span className="mis-value">{payoutOption}</span>
          </div>
          <div className="mis-highlight highlight-5">
            <span className="mis-label">Maturity Instruction :</span> <span className="mis-value">{maturityInstruction}</span>
          </div>
        </div>
      )}
    </div>
  );
}
